// @ts-nocheck
import React, { useState } from "react";
import { FaStar, FaTimes, FaCheckCircle } from "react-icons/fa";
import { useLanguageContext } from "../context/languageContext";
import { useSelector } from "react-redux";
import { API_URL } from "../config/api";

export const ReviewModal = ({ isOpen, onClose, type = "SUGGESTION", orderId = null, serviceId = null }) => {
    const { t } = useLanguageContext();
    const [rating, setRating] = useState(0);
    const [hover, setHover] = useState(0);
    const [comment, setComment] = useState("");
    const [customerName, setCustomerName] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    const businessId = useSelector((state) => state.business.businessId) || 2;
    const PUBLIC_TOKEN = "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJkZW5pcy5taW1pbmlAY2xpY2thbGJhbmlhLmNvbSIsImlhdCI6MTc1MDk4MjU3NywiZXhwIjoxNzUxMjQxNzc3fQ.yQ3xGQEfpj62ruJoLJYOl3966g55OlyofRqjoAHzu";

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (rating === 0 && type !== "SUGGESTION") return;

        setIsSubmitting(true);
        try {
            const response = await fetch(`${API_URL}/api/review`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${PUBLIC_TOKEN}`,
                },
                body: JSON.stringify({
                    type,
                    orderId,
                    serviceId,
                    rating,
                    comment,
                    customerName,
                    businessId,
                    registrationTime: new Date().toISOString()
                }),
            });

            if (response.ok) {
                setIsSuccess(true);
                setTimeout(() => {
                    onClose();
                    setIsSuccess(false);
                    setRating(0);
                    setComment("");
                    setCustomerName("");
                }, 2000);
            } else {
                alert(t("Failed to submit review."));
            }
        } catch (error) {
            console.error("Error submitting review:", error);
            alert(t("Failed to submit review."));
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center px-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in">
            <div className="bg-white w-full max-w-md rounded-[2rem] overflow-hidden shadow-2xl animate-app-reveal relative">
                {/* Header */}
                <div className="bg-slate-900 px-8 py-6 text-white relative overflow-hidden">
                    <div className="absolute inset-0 opacity-20 pointer-events-none">
                        <div className="absolute top-0 right-0 w-32 h-32 bg-indigo-500 rounded-full blur-3xl -mr-16 -mt-16"></div>
                    </div>

                    <div className="relative z-10 flex items-center justify-between">
                        <div>
                            <h2 className="text-xl font-clash tracking-tight">
                                {type === "ORDER" ? t("Order Review") : type === "SERVICE" ? t("Service Review") : t("Suggestion")}
                            </h2>
                            <p className="text-white/50 text-[10px] uppercase font-black tracking-widest mt-1">
                                {t("How was your experience?")}
                            </p>
                        </div>
                        <button
                            onClick={onClose}
                            className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors"
                        >
                            <FaTimes size={14} />
                        </button>
                    </div>
                </div>

                {isSuccess ? (
                    <div className="px-8 py-16 text-center space-y-4 animate-scale-up">
                        <div className="mx-auto w-20 h-20 bg-emerald-50 rounded-full flex items-center justify-center">
                            <FaCheckCircle className="text-emerald-500 text-4xl animate-bounce-short" />
                        </div>
                        <div className="space-y-1">
                            <h3 className="text-xl font-clash text-slate-900">{t("Thank you for your feedback!")}</h3>
                            <p className="text-slate-500 text-sm font-medium">{t("Your review helps us improve our service.")}</p>
                        </div>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="p-8 space-y-6">
                        {/* Rating Selection */}
                        {type !== "SUGGESTION" && (
                            <div className="space-y-3">
                                <label className="text-[10px] font-black uppercase tracking-widest text-slate-400 block">
                                    {t("Rating")}
                                </label>
                                <div className="flex items-center gap-2">
                                    {[1, 2, 3, 4, 5].map((star) => (
                                        <button
                                            key={star}
                                            type="button"
                                            className="transition-all active:scale-90"
                                            onClick={() => setRating(star)}
                                            onMouseEnter={() => setHover(star)}
                                            onMouseLeave={() => setHover(0)}
                                        >
                                            <FaStar
                                                size={32}
                                                className={`transition-colors duration-200 ${(hover || rating) >= star ? "text-amber-400" : "text-slate-100"
                                                    }`}
                                            />
                                        </button>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Customer Name */}
                        <div className="space-y-2">
                            <label className="text-[10px] font-black uppercase tracking-widest text-slate-400 block">
                                {t("Your Name (Optional)")}
                            </label>
                            <input
                                type="text"
                                value={customerName}
                                onChange={(e) => setCustomerName(e.target.value)}
                                placeholder="e.g. John Doe"
                                className="w-full px-4 py-3 bg-slate-50 border border-slate-100 rounded-xl text-sm font-medium focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 outline-none transition-all"
                            />
                        </div>

                        {/* Comment */}
                        <div className="space-y-2">
                            <label className="text-[10px] font-black uppercase tracking-widest text-slate-400 block">
                                {t("Comment")}
                            </label>
                            <textarea
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                                placeholder={t("Share your thoughts with us...")}
                                rows={4}
                                className="w-full px-4 py-3 bg-slate-50 border border-slate-100 rounded-xl text-sm font-medium focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 outline-none transition-all resize-none"
                                required={type === "SUGGESTION"}
                            />
                        </div>

                        {/* Submit Button */}
                        <button
                            type="submit"
                            disabled={isSubmitting || (type !== "SUGGESTION" && rating === 0)}
                            className="w-full py-4 bg-slate-900 text-white rounded-xl text-xs font-black uppercase tracking-[0.2em] shadow-lg shadow-slate-900/20 hover:bg-slate-800 disabled:opacity-50 disabled:cursor-not-allowed transition-all active:scale-[0.98]"
                        >
                            {isSubmitting ? t("Submitting...") : t("Submit Review")}
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
};
